import styled from 'styled-components';

import { fadeIn, fadeOut, slideIn, slideOut } from './animations';

type ContainerProps = {
  animated: boolean;
};

export const Content = styled.div`
  background-color: #ffffff;
  width: 100%;
  height: 100%;
  max-height: 100%;
  min-height: 100%;
  max-width: 820px;
  overflow: hidden;
`;

export const Container = styled.div<ContainerProps>`
  display: flex;
  justify-content: flex-end;
  position: absolute;
  top: 0px;
  left: 0px;
  min-width: 100vw;
  min-height: 100vh;
  width: 100vw;
  height: 100vh;
  max-width: 100vw;
  max-height: 100vh;
  z-index: 9999999;
  overflow: hidden;

  &.visible {
    visibility: visible;
    background-color: rgba(0, 0, 0, 0.5);
    animation: 0.2s linear ${fadeIn};

    ${Content} {
      transform: ${({ animated }) => (animated ? 'translateY(0%)' : 'none')};
      animation: 0.2s ease-in-out ${slideIn};
    }
  }

  &.hidden {
    background-color: rgba(0, 0, 0, 0);
    visibility: hidden;
    animation: 0.2s linear ${fadeOut};

    ${Content} {
      transform: translateY(100%);
      animation: 0.2s ease-in-out ${slideOut};
    }
  }
`;
